import { post } from '@/util/auth'

const IS_NEW_BACKEND_API = true
const API_ROUTE_BUYOUT_OFFERS = 'assets/buyout-offers'

export const withdrawBuyoutOffer = async (offerId: number): Promise<void> => {
  await post(`${API_ROUTE_BUYOUT_OFFERS}/${offerId}/withdraw`, {}, IS_NEW_BACKEND_API)
}
